import type {
	DraftVerificationAttachment,
	VerificationAttachment,
} from '@api-client/api'
import { LaunchIcon } from '@assets/icons'
import { useMaybeCallback } from '@hooks/base'
import * as React from 'react'

import * as S from './styles'

interface IProps {
	label?: string
	value?:
		| readonly (VerificationAttachment | DraftVerificationAttachment)[]
		| string
		| number
	action?: (params: string) => void
	className?: string
	children?: React.ReactNode
}

const isReadonlyArray = (
	a: IProps['value']
): a is readonly (VerificationAttachment | DraftVerificationAttachment)[] =>
	!!a && Array.isArray(a)

const AttachmentItem = ({
	item,
	handleIconClick,
}: {
	item: VerificationAttachment | DraftVerificationAttachment
	handleIconClick?: (itemId: string) => void
}) => {
	const onClick = useMaybeCallback(
		(clickIcon, itemId) => clickIcon(itemId),
		[item.id],
		[handleIconClick, item.id]
	)

	return (
		<S.DetailsValue>
			{item.name}
			<S.DetailsValueIcon onClick={onClick}>
				<LaunchIcon />
			</S.DetailsValueIcon>
		</S.DetailsValue>
	)
}

const InfoKeyValue = (props: IProps) => {
	const { label, value, className, action, children } = props

	const handleIconClick = useMaybeCallback(
		(act, itemId: string) => itemId && act(itemId),
		[],
		action
	)

	if (!value || value === '-') {
		return null
	}

	return (
		<div className={className}>
			<S.DetailsLabel>
				{label} {children}
			</S.DetailsLabel>
			{isReadonlyArray(value) ? (
				value.map((item, index) => (
					<AttachmentItem
						key={item.id || index}
						item={item}
						handleIconClick={handleIconClick}
					/>
				))
			) : (
				<S.DetailsValue>{value}</S.DetailsValue>
			)}
		</div>
	)
}

export { InfoKeyValue }
